export default __webpack_public_path__ + "static/media/ring.646a4546.mp3";